import { UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromApp from '../store/app.reducer';
import { map, filter, first } from 'rxjs/operators';
import { inject } from '@angular/core';

export const onboardingAssignmentGuard = (
): Observable<boolean | UrlTree> => {
    const store = inject(Store<fromApp.AppState>);

    return store.select(state => state.auth).pipe(
        // Wait for auth to be checked (allow unauthenticated users to see calendar)
        filter(authState => authState?.authChecked === true),
        first(),
        map(() => {
            // Always allow: unauthenticated see blank calendar + Login; authenticated see data. Onboarding skipped.
            return true;
        })
    );
};